import React, {FC} from "react";
import {
    Grid,
    useMediaQuery,
} from "@mui/material";
import {IMotorcycle} from "../../../interfaces/Interfaces";
import {useNavigate} from "react-router-dom";
import {useCompare} from "../compare/CompareContext";
import {CatalogueGridItem} from "./CatalogueGridItem";
import {CatalogueListItem} from "./CatalogueListItem";
import {ViewTableStyle} from "../../../enums/ViewTableStyle";
import {RoutesPath} from "../../../enums/RoutesPath";
import theme from "../../../theme/theme";

interface ICatalogueTableItem {
    motorcycle: IMotorcycle;
    handleToggleCompare: (id: number) => void;
    viewStyle: ViewTableStyle;
    handleToggleFavorite: (motorcycleId: number) => void;
    favourites: number[];
}

export const CatalogueTableItem: FC<ICatalogueTableItem> = ({
    motorcycle,
    handleToggleCompare,
    viewStyle,
    handleToggleFavorite,
    favourites,
}) => {
    const {compareArray} = useCompare();
    const navigate = useNavigate();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const navigateToDetailsPath = `${RoutesPath.CATALOGUE}/${motorcycle.id}`;
    const handleDetailsClick = () => navigate(navigateToDetailsPath);

    const isInCompareList = compareArray.includes(motorcycle.id);
    const queryParam = compareArray.join(",");
    const navigateToComparePath = `${RoutesPath.CATALOGUE_COMPARE}?ids=${queryParam}`;
    const handleCompareClick = () => handleToggleCompare(motorcycle.id);

    const isFavourite = favourites.includes(motorcycle.id);

    return (
        <Grid
            item
            xs={viewStyle === ViewTableStyle.GRID ? (isSmallScreen ? 6 : 4
            ) : 12}
            sx={{display: "flex", justifyContent: "center"}}
        >
            {viewStyle === ViewTableStyle.GRID ? (
                <CatalogueGridItem
                    motorcycle={motorcycle}
                    handleDetailsClick={handleDetailsClick}
                    handleCompareClick={handleCompareClick}
                    handleToggleFavorite={() => handleToggleFavorite(motorcycle.id)}
                    isInCompareList={isInCompareList}
                    isFavourite={isFavourite}
                    compareArrayLength={compareArray.length}
                    navigateToDetailsPath={navigateToDetailsPath}
                    navigateToComparePath={navigateToComparePath}
                    isSmallScreen={isSmallScreen}
                />
            ) : (
                <CatalogueListItem
                    motorcycle={motorcycle}
                    handleDetailsClick={handleDetailsClick}
                    handleCompareClick={handleCompareClick}
                    handleToggleFavorite={() => handleToggleFavorite(motorcycle.id)}
                    isInCompareList={isInCompareList}
                    isFavourite={isFavourite}
                    compareArrayLength={compareArray.length}
                    navigateToDetailsPath={navigateToDetailsPath}
                    navigateToComparePath={navigateToComparePath}
                    isSmallScreen={isSmallScreen}
                />
            )}
        </Grid>
    );
};
